import React from "react"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { Popover, Chip, Menu } from "material-ui"
import { IPositionTask } from "../../../models"
import TaskList from "./TaskList"
interface IProps {
    readonly?: boolean
    requiredTasks: IPositionTask[]
    optionalTasks: IPositionTask[]
    handleAddRequiredTask(task: IPositionTask): void
    hnadleDeleteRequiredTask(task: IPositionTask): void
    handleAddOptionalTask(task: IPositionTask): void
    hnadleDeleteOptionalTask(task: IPositionTask): void
}
interface IState {
    openPopover: boolean
}

export default class PositionTask extends React.Component<IProps, IState> {
    private anchorEl
    private targetOrigin = {
        vertical: "center",
        horizontal: "left"
    }
    private anchorOrigin = {
        vertical: "center",
        horizontal: "right"
    }
    constructor(props: IProps) {
        super(props)
        this.state = {
            openPopover: false
        }
        autobind(this)
    }

    componentDidMount() {
        this.anchorEl = document.getElementById("PositionTask")
    }

    render() {
        return (
            <div>
                <div style={{ marginBottom: 10 }}>
                    <label style={{ fontSize: 12 }}>{strings.Tasks}</label>
                    <Chip
                        data-intercom-target={"Positions-Select-Task"}
                        id="PositionTask"
                        style={{ marginTop: 7 }}
                        onClick={() => this.setState({ openPopover: true })}
                    >
                        {`${strings.Tasks}: ${this.props.requiredTasks.length + this.props.optionalTasks.length}`}
                    </Chip>
                </div>
                <Popover
                    open={this.state.openPopover}
                    style={{ padding: 25, maxWidth: 500 }}
                    anchorEl={this.anchorEl}
                    anchorOrigin={this.anchorOrigin}
                    targetOrigin={this.targetOrigin}
                    onRequestClose={() => this.setState({ openPopover: false })}
                >
                    <Menu style={{ width: 300, overflowY: "hidden" }}>
                        <TaskList
                            readonly={this.props.readonly}
                            ordered
                            title={strings.RequiredTasks}
                            tasks={this.props.requiredTasks}
                            handleAddNewItem={this.props.handleAddRequiredTask}
                            onDeleteRequest={this.props.hnadleDeleteRequiredTask}
                        />
                        <TaskList
                            readonly={this.props.readonly}
                            title={strings.OptionalTasks}
                            tasks={this.props.optionalTasks}
                            handleAddNewItem={this.props.handleAddOptionalTask}
                            onDeleteRequest={this.props.hnadleDeleteOptionalTask}
                        />
                    </Menu>
                </Popover>
            </div >
        )
    }
}